import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography } from "@material-ui/core";
import {
  aprobarPresupuesto,
  cambiarEstadoPresupuesto,
  getBandejas,
  getContratoCreadoParaPresupuesto,
  moverBandejaPresupuesto,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_PRESUPUESTOS_ESTADOS, TIPOS_PRESUPUESTO } from "../../../../utils/constants";
import { Redirect } from "react-router-dom";
import { ModalNotasPresupuesto } from "./ModalNotasPresupuesto";

export const AdministrarMenuPresupuesto = (props) => {
  const dispatch = useDispatch();
  const [redirect, setRedirect] = React.useState(false);
  const [openModalCambiarEstado, setOpenModalCambiarEstado] = useState(false);
  const [idEstadoPresupuesto, setIdEstadoPresupuesto] = useState("");
  const [idBandejaPresupuesto, setIdBandejaPresupuesto] = useState("");
  const [tituloModal, setTituloModal] = useState("");
  const [idEstadoPresupuestoDevolucion, setIdEstadoPresupuestoDevolucion] = useState(AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION.toString());

  const { bandejas = [], presupuestoSeleccionado = {}, contratoCreado = {} } = useSelector(
    (state) => state.autorizaciones
  );

  useEffect(() => {
    dispatch(getBandejas());
    dispatch(getContratoCreadoParaPresupuesto(presupuestoSeleccionado.idPresupuesto));
  }, []);

  const onClickCambiarBandeja = (idBandeja) => {
    const data = {
      idPresupuesto: presupuestoSeleccionado.idPresupuesto,
      idBandejaAutorizacion: idBandeja,
    };
    dispatch(moverBandejaPresupuesto(data, props.closeModalAuditar, props.filtros));
  };

  const onClickCambiarEstadoSolicitud = (idEstadoPresupuesto, idBandejaPresupuesto = null) => {
    setOpenModalCambiarEstado(true);
    setTituloModal("Agregar nota")
    setIdEstadoPresupuesto(idEstadoPresupuesto)
    setIdBandejaPresupuesto(idBandejaPresupuesto)
  };

  const onClickAprobarPresupuesto = () => {
    dispatch(aprobarPresupuesto(presupuestoSeleccionado.idPresupuesto, props.closeModalAuditar, true, props.filtros));
  };

  return (
    <React.Fragment>
      {openModalCambiarEstado &&
        <ModalNotasPresupuesto
          open={openModalCambiarEstado}
          close={() => {
            setOpenModalCambiarEstado(false);
          }}
          guardar={(saveNote) => {
            const data = {
              idPresupuesto: presupuestoSeleccionado.idPresupuesto,
              idEstadoPresupuesto: idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION ?
                idEstadoPresupuestoDevolucion : idEstadoPresupuesto,
              idBandejaPresupuesto: idBandejaPresupuesto
            };
            dispatch(cambiarEstadoPresupuesto(data, props.closeModalAuditar, props.filtros, () => saveNote()));
          }}
          desdeIngresoSolicitud={props.desdeIngresoSolicitud}
          idPresupuesto={presupuestoSeleccionado.idPresupuesto}
          disabled={props.disabled}
          titulo={tituloModal}
          privada={true}
          idEstadoPresupuesto={idEstadoPresupuesto}
          idEstadoPresupuestoDevolucion={idEstadoPresupuestoDevolucion}
          setIdEstadoPresupuestoDevolucion={setIdEstadoPresupuestoDevolucion}
          presupuestoSeleccionado={presupuestoSeleccionado}
        //nota={editNota}
        />

      }
      {presupuestoSeleccionado?.idEstadoPresupuesto !==
        AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE_CONTRATOS
        ?
        <>
          <Typography
            variant="h6"
            style={{
              textAlign: "center",
              margin: "1.5rem 0",
            }}
          >
            Mover Bandeja:
          </Typography>
          {Array.isArray(bandejas) && bandejas.length > 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                flexWrap: "wrap",
              }}
            >
              {presupuestoSeleccionado?.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
                && bandejas?.filter(item => item.idBandeja === AUTORIZACIONES_BANDEJAS.COMPRAS ||
                  item.idBandeja === AUTORIZACIONES_BANDEJAS.CONTRATOS).map((bandeja) => {
                    return (
                      <Button
                        key={bandeja.idBandeja.toString()}
                        style={{ margin: "0.5rem", flexBasis: "30%" }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          onClickCambiarBandeja(bandeja.idBandeja);
                        }}
                      >
                        {bandeja.descripcion}
                      </Button>
                    );
                  })}
              {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
                && bandejas?.filter(item => item.idBandeja !== AUTORIZACIONES_BANDEJAS.INTERNACION_PAIS &&
                  item.idBandeja !== AUTORIZACIONES_BANDEJAS.AUDITORIA_TERRENO &&
                  item.idBandeja !== AUTORIZACIONES_BANDEJAS.COMPRAS &&
                  item.idBandeja !== AUTORIZACIONES_BANDEJAS.AUDITORIA_ADMINISTRATIVA).map((bandeja) => {
                    return (
                      <Button
                        key={bandeja.idBandeja.toString()}
                        style={{ margin: "0.5rem", flexBasis: "30%" }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          onClickCambiarBandeja(bandeja.idBandeja);
                        }}
                      >
                        {bandeja.descripcion}
                      </Button>
                    );
                  })}
            </div>
          )}
          {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
            && <Typography
              variant="h6"
              style={{
                textAlign: "center",
                margin: "1.5rem 0",
              }}
            >
              Cambiar Estado Presupuesto:
            </Typography>
          }
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              flexWrap: "wrap",
            }}
          >
            {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
              && <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "red",
                  color: "white",
                }}
                variant="contained"
                onClick={() =>
                  onClickCambiarEstadoSolicitud(
                    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO
                  )
                }
              >
                Rechazar
              </Button>
            }
            {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
              && <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "green",
                  color: "white",
                }}
                variant="contained"
                onClick={() =>
                  onClickCambiarEstadoSolicitud(
                    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO,
                    presupuestoSeleccionado?.conInternacion || !presupuestoSeleccionado?.soloMateriales ?
                      AUTORIZACIONES_BANDEJAS.CONTRATOS
                      :
                      (presupuestoSeleccionado?.soloMateriales ? AUTORIZACIONES_BANDEJAS.COMPRAS : AUTORIZACIONES_BANDEJAS.CONTRATOS)
                  )
                }
              >
                {presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS ?
                  "Enviar a Contratos"
                  :
                  !presupuestoSeleccionado?.conInternacion || presupuestoSeleccionado?.soloMateriales ? "Aprobar" : "Aprobar y Enviar a Contratos"}
              </Button>
            }
            {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
              && presupuestoSeleccionado.idBandejaAutorizacion !== AUTORIZACIONES_BANDEJAS.COMPRAS
              && presupuestoSeleccionado?.conInternacion
              && <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "green",
                  color: "white",
                }}
                variant="contained"
                onClick={() =>
                  onClickCambiarEstadoSolicitud(
                    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO,
                    AUTORIZACIONES_BANDEJAS.COMPRAS
                  )
                }
              >
                Aprobar y Enviar a Compras
              </Button>
            }
            {presupuestoSeleccionado.idBandejaAutorizacion === AUTORIZACIONES_BANDEJAS.COMPRAS &&
              presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO &&
              false /*Sector decidio ocultarlo*/ &&
              <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "yellow",
                  color: "black",
                }}
                variant="contained"
                onClick={() =>
                  onClickCambiarEstadoSolicitud(
                    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO_POR_COMPRAS
                  )
                }
              >
                AUTORIZAR
              </Button>
            }
            {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
              && <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "blue",
                  color: "white",
                }}
                variant="contained"
                onClick={() =>
                  onClickCambiarEstadoSolicitud(
                    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION
                  )
                }
              >
                Devolver
              </Button>
            }
          </div>
        </>
        :
        <>
          {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
            && <Typography
              variant="h6"
              style={{
                textAlign: "center",
                margin: "1.5rem 0",
              }}
            >
              Cambiar Estado Presupuesto:
            </Typography>
          }
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              flexWrap: "wrap",
            }}
          >
            {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
              && <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "red",
                  color: "white",
                }}
                variant="contained"
                onClick={() =>
                  onClickCambiarEstadoSolicitud(
                    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.RECHAZADO
                  )
                }
              >
                Rechazar
              </Button>
            }
            {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
              && <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "blue",
                  color: "white",
                }}
                variant="contained"
                onClick={() =>
                  onClickCambiarEstadoSolicitud(
                    AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION
                  )
                }
              >
                Devolver
              </Button>
            }
          </div>
          {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
            && <Typography
              variant="h6"
              style={{
                textAlign: "center",
                margin: "1.5rem 0",
              }}
            >
              Nuevo {(presupuestoSeleccionado?.idEfectorFacturacion &&
                presupuestoSeleccionado?.idTipoPresupuesto === TIPOS_PRESUPUESTO.CON_CONTRATO) ||
                contratoCreado
                ? 'Presupuesto'
                : 'Contrato'
              }
            </Typography>
          }
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              flexWrap: "wrap",
            }}
          >
            {presupuestoSeleccionado?.idEstadoPresupuesto !== AUTORIZACIONES_PRESUPUESTOS_ESTADOS.AUTORIZADO
              && <Button
                style={{
                  margin: "0.5rem",
                  flexBasis: "30%",
                  backgroundColor: "green",
                  color: "white",
                }}
                variant="contained"
                onClick={() => ((presupuestoSeleccionado?.idEfectorFacturacion &&
                  presupuestoSeleccionado?.idTipoPresupuesto === TIPOS_PRESUPUESTO.CON_CONTRATO) ||
                  contratoCreado) ?
                  onClickAprobarPresupuesto()
                  : setRedirect(true)}
              >
                {(presupuestoSeleccionado?.idEfectorFacturacion &&
                  presupuestoSeleccionado?.idTipoPresupuesto === TIPOS_PRESUPUESTO.CON_CONTRATO)
                  || contratoCreado ? "Aprobar" : "Generar"}
              </Button>
            }
            {redirect && (
              <Redirect
                to={{
                  pathname: "/contrataciones",
                  state: {
                    idPresupuesto: presupuestoSeleccionado.idPresupuesto,
                    generarEnBasePresupuesto: true
                  },
                }}
              />
            )}
          </div>
        </>
      }

    </React.Fragment>
  );
};
